import { render } from "./PedidoEmAndamentoPDF.vue?vue&type=template&id=8ef8e6cc&scoped=true"
import script from "./PedidoEmAndamentoPDF.vue?vue&type=script&lang=js"
export * from "./PedidoEmAndamentoPDF.vue?vue&type=script&lang=js"

import "./PedidoEmAndamentoPDF.vue?vue&type=style&index=0&id=8ef8e6cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef8e6cc"]])

export default __exports__